/// <amd-module name="Wit/WorkItemLinksRegistration/Contracts" />

import { IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";

export interface ILinkDisplayData {
    icons: unknown[];
    id: string | number;
    displayId: string;
    title: string;
    state?: string;
    tool: string;
    linkTypeDisplayName: string;
    registeredLinkType: string;
    witLinkTypeEnd?: string;
    updateDate?: Date;
    uri: string;
    additionalData?: { [key: string]: unknown };
    group?: { id: string, displayName: string, iconName?: string };
}

export interface ILinkedArtifactAdditionalData {
    /** Tooltip */
    title?: string;
    /** Raw data (used for example for sorting). If no data is given, sort will fall back to title */
    rawData?: number | string | Date;
}

export interface IResolvedLinkDisplayData extends ILinkDisplayData {
    linkIdentifier: ILinkIdentifier;
}

export interface INewLinkData {
    title: string;
    typeData: IWorkItemTypeData;
}

export interface ILinkIdentifier {
    FldID: number;
    tool: string;
    ID?: number;
    Comment?: string;
    AddedDate?: Date;
    RemovedDate?: Date;
    CreationDate?: Date;
    LastWriteDate?: Date;
    OriginalName?: string;
    FilePath?: string;
    LinkType?: number;
    ExtID?: number;
    targetId?: number;
    sourceId?: number;
    command?: string;
    isAddedBySystem?: boolean;
    RemoteHostId?: string;
    RemoteHostName?: string;
    RemoteHostUrl?: string;
    RemoteProjectId?: string;
    RemoteStatus?: number;
    RemoteStatusMessage?: string | null;
    [key: string]: any;
}
